import Script from "next/script";
import { logger } from '@/lib/logger';

const Outfunnel = () => {
  return (
    <>
      <Script
        id="outfunnel-main"
        strategy="lazyOnload"
        src={`https://cdn.outfunnel.com/c.js?v=${new Date().toISOString().slice(0, 10)}`}
        onLoad={() => logger.log("[Outfunnel] Script loaded successfully")}
        onError={(e) => logger.error("[Outfunnel] Failed to load script:", e)}
      />
      <Script id="outfunnel-config" strategy="lazyOnload">
        {`
          window.OFID = "5e62366438e5c01e50727587";
          ${process.env.NODE_ENV !== 'production' ? 'console.log("[Outfunnel] Set OFID:", window.OFID);' : ''}
        `}
      </Script>
    </>
  );
};

export default Outfunnel;